import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 0 1rem;
  background-color: #384245;
  overflow: hidden;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1480px;
  margin: 0 auto;

  @media (min-width: 1280px) {
    padding: 0 2rem;
    flex-direction: row;
  }
`;

export const Video = styled.div`
  flex: 1;
  margin-top: 2rem;
  text-align: center;

  @media (min-width: 1280px) {
    margin-right: 2rem;
  }
`;

export const VideoTitle = styled.h2`
  color: #fff;
  font-size: 2rem;
`;

export const VideoContainer = styled.h2`
  height: 20rem;
`;
